// extracted by mini-css-extract-plugin
export var layoutContainer = "_4h-0";
export var layoutContainerNoRounding = "_4h-6";
export var layoutContainerOpen = "_4h-5";
export var layoutContainerResizing = "_4h-1";
export var mainContent = "_4h-2";
export var resizeDivider = "_4h-3";
export var slidePanel = "_4h-4";